import { makeStyles } from '@material-ui/core/styles';

export default makeStyles({
  align: {
    paddingBottom: '4px !important',
  },
  datePickerWrapper: {
    width: '100%',
    '& .react-datepicker-wrapper': {
      width: '100%',
    },
  },
});
